<article>
	<main>
		<header>{{_title()}}</header>
		<section>
			<ng-content></ng-content>
		</section>

	</main>
</article>
